export function profileUnitMatchesSize(type, size, unit) {
  if (!size) return true;
  if (type === 'self-storage') {
    const supportedSizes = ['5x5', '5x10', '10x10', '10x15', '10x20', '10x30'];
    return supportedSizes.includes(size) && unit.classList.contains(`unit-size-${size}`);
  }
  if (type !== 'vehicle-storage') return false;

  const length = Number(unit.dataset.unitLength);
  if (!Number.isFinite(length)) return false;
  // Legacy result options label parking/RV lengths; use raw API length with the existing 20% tolerance.
  const targetLength = Number(size.split('x')[1]);
  if (!Number.isFinite(targetLength)) return false;
  return length >= targetLength * 0.8 && length <= targetLength * 1.2;
}
